/**
 * 文章请求模块
 */
import request from "@/utils/request"
import { jsonHeaders, objCoverFormData, postForm } from "@/utils/form"
/**
 * 获取文章列表
 */

export const getCurrentUserInfo = (params) => {
    return request({
        method: "POST",
        url: "/Api/User/UserInfo",
        params
    })
}

export const GetPublicPaperDetail = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetPublicPaperDetail",
        params
    })
}

export const GetMedicalPaper = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetMedicalPaper",
        params
    })
}

// 获取自建试卷详情
export const GetMedicalPaperDetail = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetMedicalPaperDetail",
        params
    })
}

// 保存试卷答案
export const SaveCommonAnser = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/SaveCommonAnser",
        params
    })
}

// 提交普通试卷
export const SubmitCommonExam = (data) => {
    return request({
        method: "POST",
        url: "/Api/Medical/SubmitCommonExam",
        headers: jsonHeaders,
        data: JSON.stringify(data)
    })
}

// 获取试卷列表
export const GeteOnlineExamList = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GeteOnlineExamList",
        params
    })
}

// 获取考场须知\配置信息
export const GetExamNoteInfo = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetExamNoteInfo",
        params
    })
}

// 获取考试试卷信息
export const GetExamTestInfo = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetExamTestInfo",
        params
    })
}

// 考生开始答题
export const WriteCacheStartAnswer = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/WriteCacheStartAnswer",
        params
    })
}

// 提交在线考试试卷
export const SubmitOnlineExam = (data) => {
    return request({
        method: "POST",
        url: "/Api/Medical/SubmitOnlineExam",
        headers: jsonHeaders,
        data: JSON.stringify(data)
    })
}

// -----------才士库
// 获取公共库试卷详情
export const GetMedicalPaperDetailCs = (params) => {
    return request({
        method: "POST",
        url: "/Api/Paper/GetMedicalPaperDetail",
        params
    })
}

// (原)获取分类（公共题库）
// export const GetSystemCategoryInfo = (params) => {
//     return request({
//         method: "POST",
//         url: "/Api/Category/GetSystemCategoryInfo",
//         params
//     })
// }
// (新)获取分类（公共题库）
export const GetSystemCategoryInfo = (params) => {
    return request({
        method: "POST",
        url: "/Manage/Platform/GetSystemCategoryList",
        params
    })
}

// 获取章节信息
export const GetChapterInfo = (params) => {
    return request({
        method: "POST",
        url: "/Api/Category/GetChapterInfo",
        params
    })
}

// 按章节查询试题列表

export const GetMedicalQueationDetailByClassId = (params) => {
    return request({
        method: "POST",
        url: "/Api/Question/GetMedicalQueationDetailByClassId",
        params
    })
}

// 试题详情
export const getDoctorTopicDetail = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetMedicalQueationDetail",
        params
    })
}

// 添加做题\错题日志
export const AddQuestionLog = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/AddQuestionLog",
        params
    })
}

// ------------------------------ 试题

// 获取试题列表
export const getProlemList = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetMedicalQueation",
        params
    })
}
// 获取试题详情
export const GetMedicalQueationDetail = (params) => {
    return request({
        method: "POST",
        url: "/Api/Question/GetMedicalQueationDetail",
        params
    })
}

// 获取公共试题题库
export const GetPublicQueationDetail = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetPublicQueationDetail",
        params
    })
}

// 高频考题分类
export const CurrentClass = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/CurrentClass",
        params
    })
}

// 获取闯关列表
export const RushSubList = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/RushSubList",
        params
    })
}

// 收藏
export const MyCollection = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/Collection",
        params
    })
}

// 取消收藏
export const MyCancelCollection = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/CancelCollect",
        params
    })
}

// 首页执业资格分类模块统计
export const GetCategoryModuleTypeCount = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetCategoryModuleTypeCount",
        params
    })
}

// 科室统计
export const GetQuestionTypeCountNew = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetQuestionTypeCountNew",
        params
    })
}

export const GetQuestionChildTypeCountNew = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetQuestionChildTypeCountNew",
        params
    })
}

export const DeleteErrSubjectLog = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/DeleteErrSubjectLog",
        params
    })
}

// 删除试题记录（重做）
export const DeleteErrSubjectLogArray = (data) => {
    return request({
        method: "POST",
        url: "/Api/Medical/DeleteErrSubjectLogArray",
        data
    })
}

// 添加做题集合
// export const AddQuestionLogList = (params) => {
//     return request({
//         method: "POST",
//         url: "/Api/Medical/AddQuestionLogList",
//         params
//     })
// }

export async function AddQuestionLogList(params) {
    return postForm("/Api/Medical/AddQuestionLogList", params)
}

// 按章节查询试题列表
export const GetMedicalQueationDetailByChapterId = (params) => {
    return request({
        method: "POST",
        url: "Api/Question/GetMedicalQueationDetailByChapterId",
        params
    })
}
